import { GAME_WIDTH, BOARD_OFFSET_Y } from './constants';

/**
 * Per-level board geometry. Replaces hardcoded BOARD_ROWS/BOARD_COLS/CELL_SIZE
 * for rendering and UI layout, allowing each level to have its own grid dimensions.
 */
export interface BoardGeometry {
  rows: number;
  cols: number;
  cellSize: number;
  offsetX: number;
  offsetY: number;
  boardWidth: number;   // cols * cellSize
  boardHeight: number;  // rows * cellSize
}

/**
 * Compute rendering geometry for a given grid.
 * Fits the board into a 672px max area (matching current 42*16=672),
 * centers horizontally in GAME_WIDTH (960), keeps existing top offset.
 */
export function computeBoardGeometry(grid: ArrayLike<ArrayLike<unknown>>): BoardGeometry {
  const rows = grid.length;
  const cols = grid[0]?.length ?? 0;
  // Fit into available board area (672px max, matching current 42*16=672)
  const maxBoardPx = 672;
  const cellSize = Math.max(1, Math.floor(maxBoardPx / Math.max(rows, cols)));
  const boardWidth = cols * cellSize;
  const boardHeight = rows * cellSize;
  const offsetX = Math.floor((GAME_WIDTH - boardWidth) / 2);
  const offsetY = BOARD_OFFSET_Y;
  return { rows, cols, cellSize, offsetX, offsetY, boardWidth, boardHeight };
}
